import { AndroidDeviceOwnerCompliancePolicy } from '@microsoft/microsoft-graph-types-beta';
import { getIntunePolicyAssignmentsFromSchema } from '../../helper';
import { PolicyAssignment } from 'projects/angular-clarity/src/app/stores/client/graph/intune/compliance-policies/policies/model';
import { AndroidCompliancePolicySchema } from 'projects/angular-clarity/src/app/modules/sway/tools/schemas/graph/intune/compliance-policies/android-compliance-policy/model';
import {
    createCompliancePolicy,
    updateCompliancePolicy,
} from 'projects/angular-clarity/src/app/stores/client/graph/intune/compliance-policies/policies/actions';

export function Remediate(
    _tenant: string,
    data: PolicyAssignment<AndroidDeviceOwnerCompliancePolicy>[],
    schema: AndroidCompliancePolicySchema,
) {
    const displayName = schema.contains.properties.policy.properties.displayName?.const;

    const currentPolicy = data.find((res) => res.policy?.displayName === displayName);

    const policy = {
        '@odata.type': '#microsoft.graph.androidDeviceOwnerCompliancePolicy',
        displayName: schema.contains.properties.policy.properties.displayName?.const,
        description: schema.contains.properties.policy.properties.description?.const,

        passwordRequired: schema.contains.properties.policy.properties.passwordRequired?.const,
        passwordMinimumLength: schema.contains.properties.policy.properties.passwordMinimumLength?.const || null,
        passwordRequiredType: schema.contains.properties.policy.properties.passwordRequiredType?.const || null,
        passwordMinutesOfInactivityBeforeLock:
            schema.contains.properties.policy.properties.passwordMinutesOfInactivityBeforeLock?.const || null,
        passwordExpirationDays: schema.contains.properties.policy.properties.passwordExpirationDays?.const || null,
        passwordPreviousPasswordCountToBlock:
            schema.contains.properties.policy.properties.passwordPreviousPasswordCountToBlock?.const || null,
        storageRequireEncryption: schema.contains.properties.policy.properties.storageRequireEncryption?.const,
        securityRequireIntuneAppIntegrity:
            schema.contains.properties.policy.properties.securityRequireIntuneAppIntegrity?.const,
        osMinimumVersion: schema.contains.properties.policy.properties.osMinimumVersion?.const || null,
        osMaximumVersion: schema.contains.properties.policy.properties.osMaximumVersion?.const || null,
        minAndroidSecurityPatchLevel:
            schema.contains.properties.policy.properties.minAndroidSecurityPatchLevel?.const || null,
        deviceThreatProtectionRequiredSecurityLevel:
            schema.contains.properties.policy.properties.deviceThreatProtectionRequiredSecurityLevel?.const,
        advancedThreatProtectionRequiredSecurityLevel:
            schema.contains.properties.policy.properties.advancedThreatProtectionRequiredSecurityLevel?.const,
        securityRequireSafetyNetAttestationBasicIntegrity:
            schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationBasicIntegrity?.const ||
            null,
        securityRequireSafetyNetAttestationCertifiedDevice:
            schema.contains.properties.policy.properties.securityRequireSafetyNetAttestationCertifiedDevice?.const ||
            null,
        // add new props here
    };

    const assignments = getIntunePolicyAssignmentsFromSchema(
        schema,
        '#microsoft.graph.deviceCompliancePolicyAssignment',
    );

    // need to update store
    if (currentPolicy?.id) {
        // if we have compliance policy
        return updateCompliancePolicy({ _tenant, policy: { ...policy, id: currentPolicy.id }, assignments });
    } else {
        // const gracePeriodHours = schema.contains.properties.policy.properties.validOperatingSystemBuildRanges
        return createCompliancePolicy({
            _tenant,
            policy: {
                ...policy,

                scheduledActionsForRule: [
                    {
                        ruleName: 'DeviceNonCompliance',
                        scheduledActionConfigurations: [
                            {
                                actionType: 'block',
                                gracePeriodHours: 0, // 2 * 24 // convert days to hours
                            },
                        ],
                    },
                ],
            },
            assignments,
        });
    }
}
